import { render } from "./CreatProject.vue?vue&type=template&id=0d772eae&scoped=true"
import script from "./CreatProject.vue?vue&type=script&lang=js"
export * from "./CreatProject.vue?vue&type=script&lang=js"

import "./CreatProject.vue?vue&type=style&index=0&id=0d772eae&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d772eae"]])

export default __exports__